"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PopupPanel_vue_1 = require("./common/PopupPanel.vue");
const PreferencesManager_1 = require("../utils/PreferencesManager");
exports.default = vue_1.default.extend({
    name: 'KeyboardShortcuts',
    components: {
        PopupPanel: PopupPanel_vue_1.default,
    },
    computed: {
        preferences() {
            return PreferencesManager_1.getPreferences;
        },
    },
});
